import Backbone from 'backbone';
import { map } from 'lodash'

const action = Backbone.Model.extend({
  tagNames(){
    return map(this.get('tags'), function(tag) { return tag.name });
  },

  outcomes() {
    return this.get('outcomes');
  },

  obstacles() {
    return this.get('obstacles');
  },

  hazards() {
    return this.get('hazards');
  },

  actions() {
    return map(this.get('character_actions'), (actionData) => {
      return new action(actionData);
    })
  }
});

export default action;

